var $6ca653959481d2db$exports = {};
$6ca653959481d2db$exports = {
    "loading": `Notiek iel\u{101}de...`,
    "loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`
};


export {$6ca653959481d2db$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
